import script from "./AchievementsLeaderBoardPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AchievementsLeaderBoardPage.vue?vue&type=script&setup=true&lang=ts"

import "./AchievementsLeaderBoardPage.vue?vue&type=style&index=0&id=f71e282e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f71e282e"]])

export default __exports__